"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("../theme");
var FlexContainer_1 = require("./FlexContainer");
var color = require("tinycolor2");
var darken = function (input, amount) { return color(input).darken(amount).toString(); };
exports.NavBar = theme_1.default(FlexContainer_1.FlexContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\tmin-height: 3em;\n\tline-height: 1em;\n\tpadding: 1em;\n\tbox-sizing: border-box;\n\tcolor: #fff;\n\tbackground-color: ", ";\n"], ["\n\twidth: 100%;\n\tmin-height: 3em;\n\tline-height: 1em;\n\tpadding: 1em;\n\tbox-sizing: border-box;\n\tcolor: #fff;\n\tbackground-color: ", ";\n"])), function (props) { return darken(props.theme.primaryColor, 5); });
exports.NavBar.displayName = 'NavBar';
var templateObject_1;
//# sourceMappingURL=NavBar.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@skeoh/pic/out/build/components/NavBar.js
// module id = 547
// module chunks = 0